var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightHos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_2191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.1697H19.4926L19.4975 5.15658C19.4456 5.14565 14.2232 3.94765 13.7015 0.141602L11.8024 0.344911C12.1165 2.63816 13.6347 4.17064 15.2024 5.1697H0.534302V6.84864H15.1703C13.6149 7.8477 12.1115 9.37799 11.8 11.6559L13.699 11.8592C14.2084 8.14283 19.2453 6.9033 19.4777 6.84864H19.5V5.1697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_2191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9657,
    height: 11.7176,
    fill: "white",
    transform: "translate(0.534302 0.141602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightHos);
export default __webpack_public_path__ + "static/media/arrow-right-hos.57b089174f3152faff62100f19a661f4.svg";
export { ForwardRef as ReactComponent };